import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface ImageUploaderProps {
  error?: boolean;
  helperText?: string;
  label?: string;
  image?: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Dropzone: FC<ImageUploaderProps> = ({
  error,
  helperText,
  image,
  onChange,
  label,
  name,
}) => {
  const { t } = useTranslation();

  return (
    <div className="h-full">
      {label && (
        <label className="inline-block mb-4 sm:mb-0 sm:mr-5 sm:text-right ml-2">
          <div className="text-left">
            <div className="flex items-center">
              <div className="font-medium">{label}</div>
            </div>
          </div>
        </label>
      )}

      <div
        className={`flex flex-col items-center p-4 border-2 rounded-md cursor-pointer relative ${
          error ? "border-red-500" : "border-slate-300/60"
        } border-dashed`}
      >
        <label className="w-full h-full flex items-center justify-center cursor-pointer">
          <input
            name={name}
            type="file"
            accept="image/jpg, image/jpeg, image/png"
            onChange={onChange} 
            className="absolute inset-0 opacity-0 cursor-pointer h-full"
          />
          {image ? (
            <img
              src={image}
              alt="Preview"
              className="max-w-xs rounded-md border border-gray-300"
            />
          ) : (
            <span className="text-gray-500">
              {label}
            </span>
          )}
        </label>
      </div>

      {helperText && (
        <p
          className="mt-1 text-sm text-red-500"
        >
          {helperText}
        </p>
      )}
    </div>
  );
};

